import clsx from "clsx";

export function ChainBadge({ chain }: { chain: "base" | "apechain" }) {
  return (
    <span
      className={clsx(
        "inline-block rounded border px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wider font-mono",
        chain === "base"
          ? "border-accent/60 bg-accent/10 text-accent shadow-[0_0_6px_rgba(255,45,146,0.3)]"
          : "border-accent2/60 bg-accent2/10 text-accent2 shadow-[0_0_6px_rgba(255,132,200,0.3)]"
      )}
    >
      {chain === "base" ? "BASE" : "APE"}
    </span>
  );
}
